import React, { Dispatch, useContext, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontWeight, Heading, Text, LiliButton } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReportFlowStep, USERS_TYPES_STYLES } from '../../constants';
import { report } from '../../../../assets/svg';
import Icon from '../../../../generic-components/Icon';
import Spinner, { SpinnerColor } from '../../../../generic-components/Spinner';
import { UserMessage } from '../../../../DesignSystem/LiliUserMessage/UserMessage';
import { validateFeatureFlag } from '../../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../../constants/general';
import { ProfitAndLossContext } from '../../pages';
import { VIEWS_MAP } from '../../../../router/constants';

interface IProps {
  setActiveStep: Dispatch<React.SetStateAction<ReportFlowStep>>;
}

export const SmartAndPremiumIntro = ({ setActiveStep }: IProps) => {
  const { t } = useTranslation('reportsEN');
  const [shouldShowLoader, setShouldShowLoader] = useState(false);
  const context = useContext(ProfitAndLossContext);
  const location = useLocation();

  const isTrxToCategorize = useMemo(
    () => !!(context?.toggleData?.incomeTrxCnt || context?.toggleData?.expenseTrxCnt),
    [context?.toggleData],
  );

  const handleClick = () => {
    setShouldShowLoader(true);

    if (validateFeatureFlag(FEATURE_FLAG.CATEGORIZATION.FEATURE) && isTrxToCategorize) {
      setActiveStep(ReportFlowStep.CATEGORIZE_TRANSACTIONS);
      setShouldShowLoader(false);
    } else if (!isTrxToCategorize) {
      setActiveStep(ReportFlowStep.REPORT);
      setShouldShowLoader(false);
    } else {
      // Show some error component
    }
  };
  const reportIntroData = (() => {
    switch (location.pathname.replace('/', '')) {
      case VIEWS_MAP.STATEMENT_OF_CASH_FLOWS:
        return {
          title: t('REPORTS.INTRO.TITLE.CASH_FLOW'),
          titleId: 'cash-flow-generate-report-title',
          subtitle: t('REPORTS.INTRO.SUBTITLE.CASH_FLOW'),
          subtitleId: 'cash-flow-generate-report-subtitle',
          ctaId: 'cash-flow-smart_and_premium_start_button',
        };
      case VIEWS_MAP.PROFIT_AND_LOSS:
        return {
          title: t('REPORTS.INTRO.TITLE.PROFIT_AND_LOSS'),
          titleId: 'profit-loss-generate-report-title',
          subtitle: t('REPORTS.INTRO.SUBTITLE.PROFIT_AND_LOSS'),
          subtitleId: 'profit-loss-generate-report-subtitle',
          ctaId: 'profit-loss-smart_and_premium_start_button',
        };
      case VIEWS_MAP.EXPENSES:
        return {
          title: t('REPORTS.INTRO.TITLE.EXPENSES'),
          titleId: 'expense-generate-report-title',
          subtitle: t('REPORTS.INTRO.SUBTITLE.EXPENSES'),
          subtitleId: 'expense-generate-report-subtitle',
          ctaId: 'expense-smart_and_premium_start_button',
        };
      default:
        return { title: '', id: '', reportName: '', ctaId: '' };
    }
  })();
  return (
    <div className={USERS_TYPES_STYLES.WRAPPER}>
      <Icon className='w-[109px] h-[109px]' src={report} />
      <Heading.H5
        id={reportIntroData.titleId}
        fontWeight={FontWeight.MEDIUM}
        className='text-text-main-primary  mt-[14px]'
      >
        {reportIntroData.title}
      </Heading.H5>

      <Text.H9 id={reportIntroData.title} className='text-text-main-secondary text-center max-w-[300px]  mb-[30px]'>
        {reportIntroData.subtitle}
      </Text.H9>
      <LiliButton
        id={reportIntroData.ctaId}
        title={t('REPORTS.INTRO.START_BUTTON')}
        onClick={handleClick}
        className='w-[166px]'
      />
      {shouldShowLoader && (
        <div className='absolute inset-0 flex items-center justify-center'>
          <UserMessage onClick={() => {}} id='spinnerLoader'>
            <Spinner spinnerColor={SpinnerColor.Blue} height='50px' width='50px' />
          </UserMessage>
        </div>
      )}
    </div>
  );
};
